import React, { useRef } from "react";
import Modal from '@material-ui/core/Modal';

import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent";

import List from '@material-ui/core/List';
import ListItem from "@material-ui/core/ListItem";
import ListItemText from '@material-ui/core/ListItemText';
import Tooltip from '@material-ui/core/Tooltip';

import {
  apollo_useStyles,
  getModalStyle,
} from "../../atom/Apollo_styles";
import CardActions from "@material-ui/core/CardActions/CardActions";
import { useHistory } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import classNames from "classnames";

import {
  signin_path,
  signout_api,
} from "../../atom/Apollo_links";

import { ApolloContext } from "../../atom/Apollo_Context";
import Grid from "@material-ui/core/Grid";
import axios from "axios";
import moment from "moment";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import Collapse from "@material-ui/core/Collapse/Collapse";
import { APOLLO_PROFILE_SYSTEM_ADMIN, APOLLO_PROFILE_SYSTEM_OPERATOR } from "../../atom/Apollo_Authorization";

import { ApolloEventRecord, LogData } from "../../atom/Apollo_EventRecord";
import { ApolloSideMenuControl } from "../../atom/SYSTEMMNG/Apollo_SideMenuControl";

export const UserPofileModal = (props: { setOpen: any }) => {

  const classes = apollo_useStyles();
  const history = useHistory();

  const [modalStyle] = React.useState(getModalStyle);
  const [open, setOpen] = React.useState(false);
  const [roleOpen, setRoleOpen] = React.useState(false);
  const { state, dispatch } = React.useContext(ApolloContext);
  const processing = useRef(false);

  // モーダルオープン
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onSubmit = async () => {
    if (processing.current) return;
    processing.current = true;

    // 実行時ログ
    const executionLog: LogData = {
      eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
      logType: "execute",
      result: "",
      userID: state.userprofile.userId,
      userName: state.userprofile.userName,
      accessToken: state.accesstoken,
      accountGroupID: state.current.accountGroupId,
      accountGroupName: state.current.accountGroupName,
      accountID: state.current.accountId,
      accountName: state.current.accountName,
      campaignID: "", // キャンペーンID
      campaignName: "", // キャンペーン名
      adGroupID: "", // 広告グループID
      adGroupName: "", // 広告グループ名
      menu: "",
      displayName: "ログアウト画面",
      category: "認証",
      actionType: "サインアウト",
      targetID: "",
      targetName: "",
      itemList: [],
    }
    ApolloEventRecord(executionLog);

    //API コール
    const urlstring = process.env.REACT_APP_API_ENDPOINT + signout_api;

    var senddata = {
      accountGroupId: state.current.accountGroupId,
      accountId: state.current.accountId,
      trackerId: state.current.trackerId,
      campaignId: state.current.campaignId,
    }
    //Ajax コール
    await axios.post(urlstring, senddata, {
      xsrfHeaderName: 'X-CSRF-Token',
      withCredentials: false,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${state.accesstoken}`,
      }
    })
      .then(function (response) {
        //エラーでもリダイレクト
      })
      .catch(function (error) {
        //エラーでもリダイレクト
      });
    dispatch({
      type: "clearAccount",
      payload: {
        ...state,
      }
    })

    localStorage.clear();
    sessionStorage.clear();
    setOpen(false);
    processing.current = false;
    history.push(signin_path);
  };

  return (
    <div>
      <Tooltip title="ユーザー情報" placement="bottom">
        <IconButton color="inherit" onClick={() => handleOpen()}>
          <img src={"/icon/icon_user.png"} alt="icon_user" height="auto" width="40" />
        </IconButton>
      </Tooltip>

      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={open}
        onClose={handleClose}
      >
        <div style={modalStyle} className={`${classes.paper} ${classes.modalStyleWide}`}>
          <React.Fragment>
            <Card elevation={0} className={classes.UserProfileModalCard}>
              <CardContent className={classes.UserProfileModalCardContent}>
                <div>
                  <List>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={5}>
                        <ListItem>
                          <ListItemText primary={"ユーザー名"} />
                        </ListItem>
                      </Grid>
                      <Grid item xs={12} md={5}>
                        <ListItem>
                          <ListItemText primary={state.userprofile.userName} />
                        </ListItem>
                      </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={5}>
                        <ListItem>
                          <ListItemText primary={"メールアドレス"} />
                        </ListItem>
                      </Grid>
                      <Grid item xs={12} md={5}>
                        <ListItem>
                          <ListItemText primary={state.userprofile.mailAddress} />
                        </ListItem>
                      </Grid>
                    </Grid>

                    <ApolloSideMenuControl setOpen={props.setOpen} />

                    <Grid container spacing={2}>
                      <Grid item xs={12} md={5}>
                        <ListItem>
                          <ListItemText primary={"権限リスト"} />
                        </ListItem>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <ListItem>
                          {state.userprofile.systemAdmin === APOLLO_PROFILE_SYSTEM_ADMIN &&
                            <ListItemText primary={"システム管理権限を所有しています"} />
                          }
                          {state.userprofile.systemAdmin === APOLLO_PROFILE_SYSTEM_OPERATOR &&
                            <ListItemText primary={"システム運用権限を所有しています"} />
                          }
                        </ListItem>
                      </Grid>
                    </Grid>
                    <IconButton aria-label="expand row" size="small" onClick={() => setRoleOpen(!roleOpen)}>
                      {roleOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                    <Collapse in={roleOpen} timeout="auto" unmountOnExit>
                      <Grid container spacing={2}>
                        {state?.authorization?.map((authRow) => (
                          <ListItem
                            key={authRow.roleId}>
                            <ListItemText primary={authRow.roleName} />
                          </ListItem>
                        ))}
                      </Grid>
                    </Collapse>
                  </List>
                </div>
              </CardContent>
              <CardActions>
                <Grid item xs={12} md={12}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    onClick={onSubmit}
                    className={classes.buttonMiddle}
                  >
                    サインアウト
                  </Button>
                </Grid>
              </CardActions>
            </Card>
          </React.Fragment>
        </div>
      </Modal>
    </div>
  );
};
